"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = toArray;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

/**
 * Helper to convert objects into arrays of transforms. probably belongs in
 * webex-core
 * @param {string} direction "inbound"|"outbound"
 * @param {Object} obj
 * @private
 * @returns {Array}
 */
function toArray(direction, obj) {
  return (0, _keys.default)(obj).map(function (name) {
    var entry = obj[name];

    if ((0, _isFunction2.default)(entry)) {
      return {
        name: name,
        direction: direction,
        fn: entry
      };
    }

    return (0, _assign.default)({
      name: name
    }, entry);
  });
}
//# sourceMappingURL=to-array.js.map
